'use client'

// PostHog analytics has been removed (no active subscription).
// These are no-op stubs that preserve the public API so existing call sites
// keep compiling and behave gracefully — analytics events and error captures
// are simply dropped instead of being sent anywhere.
//
// `posthog-js` is imported for TYPES ONLY (erased at build time), so the
// consumers below keep their original typing without pulling the PostHog
// runtime into the bundle or making any network calls.
import type posthog from 'posthog-js'

export function captureError(_error: Error, _extra?: Record<string, unknown>): void {
  // no-op: PostHog error tracking is disabled
}

// Returns the PostHog instance if initialized, null otherwise.
// Always null now that PostHog is removed.
export function getPostHog(): typeof posthog | null {
  return null
}

// Register a callback to be called when PostHog is ready.
// PostHog never becomes ready, so the callback is never invoked.
// Returns a no-op unsubscribe function.
export function onPostHogReady(_callback: (ph: typeof posthog) => void): () => void {
  return () => {}
}
